
import React from "react";
import { Row, Col, Button, Space, Typography } from "antd";
import { LeftCircleFilled } from "@ant-design/icons";
import { Link } from "react-router-dom";
const { Title } = Typography;

type PageHeaderProps = {
    title: string;
    subTitle?: string;
    extra?: React.ReactNode;
    backUrl?: string;
    footer?: React.ReactNode;
}

const PageHeader: React.FC<PageHeaderProps> = ({
    title,
    subTitle,
    extra,
    backUrl,
    footer
}: PageHeaderProps) => {

    return (
        <div className="page-heading mb-6">
            <Row align="top" className="mb-1">
                <Col>
                    <Space align="start">
                        {backUrl && (
                            <Link to={backUrl}>
                                <Button icon={<LeftCircleFilled />} />
                            </Link>
                        )}
                        <div>
                            <Title className="mt-0" level={2}>{title}</Title>
                            {subTitle && <Title level={5} type="secondary">{subTitle}</Title>}
                            {footer ? footer : null}
                        </div>
                    </Space>
                </Col>
                <Col flex="auto" style={{ textAlign: "right" }}>
                    <Space>{extra}</Space>
                </Col>
            </Row>
        </div>
    );
};

export default PageHeader;